import { render, staticRenderFns } from "./configuration-audit-details.component.vue?vue&type=template&id=59f0b958&scoped=true"
import script from "./configuration-audit-details.component.vue?vue&type=script&lang=ts"
export * from "./configuration-audit-details.component.vue?vue&type=script&lang=ts"
import style0 from "./configuration-audit-details.component.vue?vue&type=style&index=0&id=59f0b958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f0b958",
  null
  
)

export default component.exports